export const tokenList = [
    {
        address: 'secret1k0jntykt7e4g3y88ltc60czgjuqdy4c9e8fzek',
        symbol: 'sSCRT',
        icon: 'secret-network.svg',
        decimals: 6,
    },
    {
        address: 'secret18wpjn83dayu4meu6wnn29khfkwdxs7kyrz9c8f',
        symbol: 'sUSDT',
        icon: 'usdt_ethereum.svg',
        decimals: 6,
    },
    {
        address: 'secret12rcvz0umvk875kd6a803txhtlu7y0pnd73kcej',
        symbol: 'ALTER',
        icon: 'alter.svg',
        decimals: 6,
    },
    {
        address: 'secret14mzwd0ps5q277l20ly2q3aetqe3ev4m4260gf4',
        symbol: 'sATOM',
        icon: 'atom.png',
        decimals: 6,
    },
    {
        address: 'secret1ra7avvjh9fhr7dtr3djutugwj59ptctsrakyyw',
        symbol: 'sLUNC',
        icon: 'luna.png',
        decimals: 6,
    },
    {
        address: 'secret15l9cqgz5uezgydrglaak5ahfac69kmx2qpd6xt',
        symbol: 'SEFI',
        icon: 'sefi.svg',
        decimals: 6,
    },
    {
        address: 'secret1zwwealwm0pcl9cul4nt6f38dsy6vzplw8lp3qg',
        symbol: 'sOSMO',
        icon: 'osmo.png',
        decimals: 6,
    },
    {
        address: 'secret19ungtd2c7srftqdwgq0dspwvrw63dhu79qxv88',
        symbol: 'sXMR',
        icon: 'sxmr.png',
        decimals: 12,
    },
    {
        address: 'secret1g7jfnxmxkjgqdts9wlmn238mrzxz5r92zwqv4a',
        symbol: 'sWBTC',
        icon: 'wbtc_ethereum.svg',
        decimals: 8,
    },
    {
        address: 'secret1tact8rxxrvynk4pwukydnle4l0pdmj0sq9j9d5',
        symbol: 'sBNB',
        icon: 'bnb_binance.svg',
        decimals: 18,
    }
]